// Cliente Microsoft Graph del Dashboard JMA AFAC.
//
// Usa el SDK oficial @microsoft/microsoft-graph-client con un AuthProvider
// callback que delega la adquisición silenciosa de tokens en auth-provider.js
// (MSAL.js). El SDK reintenta automáticamente si el token caduca.

import { Client } from '@microsoft/microsoft-graph-client'
import { acquireToken } from '../auth/auth-provider.js'

let cachedClient = null

export function getGraphClient() {
  if (cachedClient) return cachedClient
  cachedClient = Client.init({
    defaultVersion: 'v1.0',
    authProvider: async (done) => {
      try {
        const token = await acquireToken()
        done(null, token)
      } catch (err) {
        done(err, null)
      }
    }
  })
  return cachedClient
}

/**
 * Reinicia el cliente cacheado. Útil tras logout/login si en algún momento
 * el AuthProvider cambia el set de scopes.
 */
export function resetGraphClient() {
  cachedClient = null
}
